(function ClientOpportunityTypeAhead($, Adzuki)
{
	"use strict";

	var ClientOpportunityTypeAhead = {};

	/**
	 * Sets up the opportunity typeahead
	 */
	ClientOpportunityTypeAhead.search = function search()
	{
		Adzuki.Typeahead(
			'.opportunity-search',
			'/ClientOpportunities/typeaheadSearch',
			function select(item, $self) {
				var $parent     = $self.closest('.client-opportunity-typeahead'),
				    label       = item.name,
				    id          = item.id,
				    client_id   = item.client_id,
				    client_name = item.client_name;

				$self.val(label);
				$self.prop("disabled", true);
				$parent.find('.opportunity-id').val(id).trigger('change');
				$parent.find('.opportunity-client-id').val(client_id).trigger('change');
				$parent.find('.opportunity-client-name').val(client_name).trigger('change');
				$parent.find('.opportunity-selected').removeClass('hidden');
			},
			function template(item) {
				var html = item.name;
				return html;
			}
		);
	};

	/**
	 * Clears an opportunity typeahead selection
	 * @param  jQuery object $element element prompting the clear out
	 */
	ClientOpportunityTypeAhead.clearSearch = function clearSearch($element)
	{
		var $container   = $element.closest('.client-opportunity-typeahead'),
		    $id          = $container.find('.opportunity-id'),
		    $client_id   = $container.find('.opportunity-client-id'),
		    $client_name = $container.find('.opportunity-client-name'),
		    $search      = $container.find('.opportunity-search'),
		    $selected    = $container.find('.opportunity-selected');

		$id.val('').trigger('change');
		$client_id.val('').trigger('change');
		$client_name.val('').trigger('change');
		$search.val('');
		$search.prop("disabled", false);
		$search.focus();
		$selected.addClass('hidden');
	};

	/**
	 * Toggles the opportunity search field viewability
	 * @param  jQuery object $element element that prompts the toggling
	 */
	ClientOpportunityTypeAhead.toggleSearchField = function toggleSearchField($element)
	{
		var el = $element.data('toggle');

		$('#' + el).collapse('toggle');
		this.clearSearch($element);
	};

	ClientOpportunityTypeAhead.showSearchField = function showSearchField($element)
	{
		var el = $element.data('toggle');

		$('#' + el).addClass('in');
		// this.clearSearch($element);
	};

	ClientOpportunityTypeAhead.hideSearchField = function hideSearchField($element)
	{
		var el = $element.data('toggle');

		$('#' + el).removeClass('in');
		this.clearSearch($element);
	};

	/**
	 * Sets up all of the event listeners.  Set it up this way because gets used within ajax content added to the page and this allow for a single call to make it all work
	 */
	ClientOpportunityTypeAhead.readyForAction = function readyForAction()
	{
		$('.toggle-sales-opportunity').on('change', function toggle() {
			if ($(this).is(':checked')) {
				Adzuki.ClientOpportunityTypeAhead.showSearchField($(this));
			} else {
				Adzuki.ClientOpportunityTypeAhead.hideSearchField($(this));
			}
		});

		$('.clear-opportunity').on('click', function clearOpportunity(e) {
			e.preventDefault();
			Adzuki.ClientOpportunityTypeAhead.clearSearch($(this));
		});

		Adzuki.ClientOpportunityTypeAhead.search();
	};


	$(document).ready(function documentReady()
	{
		if ($('.client-opportunity-typeahead').length) {
			Adzuki.ClientOpportunityTypeAhead.readyForAction();
		}

		$('.toggle-sales-opportunity').change();
	});

	Adzuki.ClientOpportunityTypeAhead = ClientOpportunityTypeAhead;

}(jQuery, window.Adzuki || {}));
